<template>
  <!-- div#body:start -->
  <div id="body"
    :class="[
    {'is-hidden-header' : targetScrollFlg},
    {'is-visible-menu': state.visibleMenu},
    {'is-visible-menu-left': state.visibleMenuLeft},
    {'is-visible-viewmode': state.isDetailMode},
    {'is-visible-editmode': state.isEditMode && !state.visibleMenu}
    ]"
  >
  <BackgroundImage />

    <!-- SPメニュー -->
    <SPMenu
      :parentVisibleMenu="state.visibleMenu"
      @closeMenu="state.visibleMenu = false"
    />

    <!-- 左ナビ -->
    <div id="menu-left" class="menu-left">
      <ul class="menu-left-list">
        <li class="menu-left-list-item">
          <span class="menu-left-list-item-label"
            @click="state.visibleNoteCopyConfirm = true;"
          >ノートの複製</span>
        </li>
        <li v-if="state.isOwn" class="menu-left-list-item">
          <span class="menu-left-list-item-label"
            @click="state.visibleNoteDeleteConfirm = true;"
          >ノートの削除</span>
        </li>
      </ul>
      <div class="menu-left-close"
        @click="state.visibleMenuLeft = false"
      >
        <span class="icn-wrap"><FontawesomeIcon :icon="['fal', 'times']" class="icn" /></span>
      </div>
    </div>

    <!-- ノート複製 -->
    <transition name="popup">
      <SPNoteCopyConfirm
        v-if="state.visibleNoteCopyConfirm"
        @closeNoteCopyConfirm="action.closeNoteCopyConfirm"
      />
    </transition>

    <!-- ノート削除 -->
    <transition name="popup">
      <SPNoteDeleteConfirm
        v-if="state.visibleNoteDeleteConfirm"
        @closeNoteDeleteConfirm="action.closeNoteDeleteConfirm"
      />
    </transition>

    <!-- 閲覧/編集権限付与アカウント一覧ウィンドウ -->
    <transition name="popup">
      <SPNoteUserPermissionsList
        v-if="state.visibleNoteUserPermissionsList"
        @close="state.visibleNoteUserPermissionsList = false"
      />
    </transition>

    <!-- 閲覧/編集権限付与設定ウィンドウ -->
    <transition name="popup">
      <SPNoteUserPermissionsEdit
        v-if="state.visibleNoteUserPermissionsEdit"
        @close="share.hideNoteUserPermissionsEdit"
      />
    </transition>


    <div id="wrapper">

      <div 
        v-show="state.visibleMenuButton"
        id="menu-btn" class="menu-btn">
        <div role="button" class="menu-btn-2"
          @click="state.visibleMenu = true"
        >
          <IconMenu class="icn" />
        </div>
      </div>

      <div id="navi-btn" class="navi-btn"
        v-if="!state.isEditMode"
        @click="state.visibleMenuLeft = true"
      >
        <FontawesomeIcon :icon="['fas', 'ellipsis-v']" class="icn" />
      </div>

      <!-- div#header:start -->
      <div id="header">
        <header class="header">
          <SPButtonHistoryBack 
            :action="historyBackAction"
          />
          <div class="header-title">
            <h1>ノート</h1>
          </div>
        </header>
      </div>

      <!-- div#header:end -->
      <div id="main">
        <div class="main">
          <div class="main-container pb0"
            :class="{'main-container-showpop': state.visiblePopup}"
            @scroll="handleScroll"
            >
            <div class="tab">
              <div class="tab-head">
                <ul class="tab-label">
                  <li
                    :role="state.isViewModeTabClickable ? 'button' : ''"
                    @click="action.onViewModeTabClicked"
                    :class="{'is-active': state.isDetailMode}"
                    class="ga-note-mode-view"
                  >
                    <span class="label ga-note-mode-view">閲覧モード</span>
                  </li>
                  <li
                    v-if="state.isEditable || state.isCreate"
                    :role="!state.isEditMode ? 'button' : ''"
                    @click="action.onEditModeTabClicked"
                    :class="{'is-active': state.isEditMode}"
                    class="ga-note-mode-edit"
                  >
                    <span class="label ga-note-mode-edit">編集モード</span>
                  </li>
                </ul>
              </div>
              <div class="tab-container">
                <div id="tab_cnt_01_01" class="tab-content"
                  v-if="state.isDetailMode"
                >
                  <FontawesomeIcon v-if="state.isLoadingDetail"
                      :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" style="margin-top: 50%;" />
                  <SPNoteDetailPart v-else
                    @openNoteUserPermissionsList="share.openNoteUserPermissionsList"
                  />
                </div>
                <div id="tab_cnt_01_02" class="tab-content"
                  v-else-if="state.isEditMode"
                >
                  <FontawesomeIcon v-if="state.isLoadingDetail"
                    :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" style="margin-top: 50%;" />
                  <SPNoteEditPart v-else
                    :parentVisibleMenu="state.visibleMenu"
                    @finishEditMode="action.changeMode('detail')"
                    @changeToDetailMode="action.onViewModeTabClickedStep2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- div#body:end -->
</template>

<script>
import { defineComponent, reactive, computed, watch, onBeforeMount } from '@vue/composition-api'

import SPMenu from '@/components/sp/popup/SPMenu.vue'
import SPNoteCopyConfirm from '@/components/sp/popup/SPNoteCopyConfirm.vue'
import SPNoteDeleteConfirm from '@/components/sp/popup/SPNoteDeleteConfirm.vue'
import SPBasicToast from '@/components/sp/popup/SPBasicToast.vue'
import SPNoteUserPermissionsList from '@/components/sp/popup/SPNoteUserPermissionsList.vue'
import SPNoteUserPermissionsEdit from '@/components/sp/popup/SPNoteUserPermissionsEdit.vue'

import SPNoteDetailPart from '@/components/sp/partial/note/SPNoteDetailPart.vue'
import SPNoteEditPart from '@/components/sp/partial/note/SPNoteEditPart.vue'

import { noteChanged, formatDate } from '@/util/common'
import store from '@/store'

export default defineComponent({
  beforeRouteLeave (to, from, next) {
    // ノートが編集中か確認し、編集中の場合は遷移させない
    if (noteChanged()) {
      store.dispatch('note/setLinkTo', { type: 'route', to: to.name})
      store.dispatch('note/showDialogToPreventForgettingToSave')
    } else {
      next()
    }
  },
  beforeRouteEnter (to, from, next) {
    const id = to.params.note_id
    Promise
      .all([
        store.dispatch('note/resetDetail'),
        store.dispatch('note/setCurrentId', id)
      ])
      .then(() => {
        if (id !== 0) {
          store.dispatch('note/getDetail')
        }
      })
    next()
  },
  components: {
    SPMenu,
    SPNoteCopyConfirm,
    SPNoteDeleteConfirm,
    SPBasicToast,
    SPNoteDetailPart,
    SPNoteEditPart,
    SPNoteUserPermissionsList,
    SPNoteUserPermissionsEdit
  },
  setup (props, context) {  
    const router = context.root.$router

    onBeforeMount(async () => {
      const currentId = store.getters['note/currentId']
      if (currentId === 0 || currentId === null) {
        // もし現在のノートIDが設定されていなければ、新規作成画面を表示する
        action.changeMode('create')
      }
    })

    const state = reactive({
      // 新規作成か？
      isCreate: computed(() => {
        return store.state.note.mode === 'create'
      }),
      // 閲覧モードタブクリック可能フラグ
      isViewModeTabClickable: computed(() => {
        return !state.isCreate && !state.isDetailMode
      }),
      isDetailMode: computed(() => store.state.note.mode === 'detail'),
      isEditMode: computed(() => store.state.note.mode === 'edit' || store.state.note.mode === 'create'),
      // メニューボタン表示フラグ
      visibleMenuButton: computed(() => {
        // 編集忘れ確認ダイアログが表示されているときはメニューボタンを非表示
        return !state.isLoadingDetail && !store.getters['note/checkForgetToSave']
      }), 
      // ロード中フラグ
      isLoadingDetail: computed(() => store.state.note.loading.detail), 
      // メニュー表示フラグ
      visibleMenu: false, 
      visibleMenuLeft: false,
      visibleNotePartAdd: false,
      visibleNotePartMove: false,
      visibleNoteCopyConfirm: false,
      visibleNoteDeleteConfirm: false,
      visibleNotePartDeleteConfirm: false,
      visibleNoteSelect: false,
      visibleQAdetailSelectNote: false,
      visibleNoteCreate: false,
      isOpenHistoryTags: false,
      isOwn: computed(() => store.getters['note/isOwn']),
      isEditable: computed(() => store.getters['note/isEditable']),
      currentId: computed(() => store.getters['note/currentId']),
      visibleNotePartPreventForgettingToSave: computed(() => store.getters['note/checkForgetToSave']),
      visiblePopup: computed(() => store.getters['note/sp_show_pop']),
      visibleNoteUserPermissionsList: false,
      visibleNoteUserPermissionsEdit: computed(() => store.state.noteUserPermissionsEdit.isVisible)
    })

    // beforeRouteLeave()内で、編集保存忘れの警告ダイアログを表示した時にメニューを非表示にする対応：
    // 「state.visibleMenu = false」を実行することができないため(stateを参照できないため)、
    // ここで、state.visibleNotePartPreventForgettingToSaveを監視(watch)し、
    // 値がtrueになったときに、「state.visibleMenu = false」を設定する
    watch(() => state.visibleNotePartPreventForgettingToSave, (now, prev) => {
      if (now) {
        state.visibleMenu = false
      }
    })

    const action = reactive({
      /**
       * モード変更
       */
      changeMode: (target) => {
        store.dispatch('note/modeChange', target) 
      },
      /**
       * 「閲覧モード」タブ押下時
       */
      onViewModeTabClicked: () => {
        if (state.isDetailMode) {
          // 既に閲覧モードの場合はクリック不可
          return
        }
        if (state.isViewModeTabClickable) {
          // 保存せずに移動しようとした場合、編集忘れ確認ダイアログを表示
          if (noteChanged()) {
            store.dispatch('note/setLinkTo', { type: 'mode', to: 'detail' })
            store.dispatch('note/showDialogToPreventForgettingToSave')
            return
          }
          // 次の処理へ
          action.onViewModeTabClickedStep2()
        }
      },
      onViewModeTabClickedStep2: () => {
        // 閲覧モードに変更
        action.changeMode('detail')
      },
      /**
       * 「編集モード」タブ押下時
       */
      onEditModeTabClicked: () => {
        if (state.isEditMode) {
          // 既に編集モードの場合はクリック不可
          return
        }
        store.dispatch('note/resetCheck')
        action.changeMode('edit')

        // ストア変数に保持されている内容が前の編集中の内容の場合があるため、対象ノートの詳細をロードしなおす。
        // また、更新APIに渡す編集開始日時(edit_start_time)に使用するため、現在の日時(サーバー時間)を取得しなおす
        store.dispatch('note/getDetail')
      },
      closeNoteCopyConfirm: () => {
        state.visibleNoteCopyConfirm = false
        store
          .dispatch('common/showToast', { text: 'ノートを複製しました' })
          .then(data => {
            setTimeout(() => {
              router.push({ path: '/sp/note-list'})
            }, 500)
          })
      },
      closeNoteDeleteConfirm: () => {
        state.visibleNoteDeleteConfirm = false
        router.push({ path: '/sp/note-list'})
      }
    })

    const share = reactive({
      /**
       * 閲覧/編集権限付与アカウント一覧ウィンドウを開く
       */
      openNoteUserPermissionsList: () => {
        state.visibleNoteUserPermissionsList = true
      },
      /**
       * 閲覧/編集権限付与設定ウィンドウを開く
       */
      openNoteUserPermissionsEdit: () => {
        store.dispatch('noteUserPermissionsEdit/show', 'select')
      },
      /**
       * 閲覧/編集権限付与設定ウィンドウを閉じる
       */
      hideNoteUserPermissionsEdit: () => {
        store.dispatch('noteUserPermissionsEdit/hide', 'select')
      }
    })


    /**
     * 編集中にヒストリーバックボタンを押したときの処理
     */
    const historyBackAction = reactive(computed(() => {
      // 編集モードの場合
      const historyBackFunc = () => {
        // 編集モードで保存せずに履歴を戻ろうとした場合、編集忘れ確認ダイアログを表示
        if (noteChanged()) {
          store.dispatch('note/setLinkTo', { type: 'mode', to: 'history_back' })
          store.dispatch('note/showDialogToPreventForgettingToSave')
          return
        }
        // 編集していない（ノートの内容が変わっていない）場合は、なにもぜず履歴を戻る
        store.dispatch('note/forceMove') 
        router.go(-1)
      }
      return historyBackFunc
    }))
    
    return {
      state,
      action,
      share,
      historyBackAction
    }
  }
})
</script>

<style lang="scss" scoped>
.main {
  &-container {
    @include changeHeightOnScroll(67px);
    &-showpop {
      height: auto;
    }
  }
}
.menu-btn {
  &-2 {
    border-top-left-radius: 8px;
  }
}
.tab {
  &-head {
    li {
      width: 50%;
      a {
        color: $color-content;
      }
      &.is-active {
        a {
          color: $color-link;
        }
      }
    }
  }
  &-container {
    overflow-y: auto;
    padding-bottom: 140px;
  }
}

.is-visible-editmode {
  .menu-btn {
    bottom: 78px;
  }
  .navi-btn {
    bottom: 98px;
  }
  .menu-close {
    bottom: 78px;
  }
}

</style>
